import api from '../api/api';
import userModel from './models/user';

if(localStorage.getItem('token')) {
    window.setTimeout(() => {
        api.setCommonHeader('Authorization', "Bearer " + localStorage.getItem('token'));
    }, 10)
}

const loginActions = {

    login({ commit }, user) {
        return new Promise((resolve, reject) => {

            commit('authRequest');

            api.auth('/login', user)
                .then(response => {

                    const user = userModel.defaultUser();
                    const token = response.data.token;
                    let u = response.data.user;

                    user.id = u.id;
                    user.displayName = u.displayName;
                    user.status = u.status;
                    user.settings = u.settings;

                    for (let i = 0; i < u.forumRoles.length; i++) {
                        user.roles.push(u.forumRoles[i]);
                    }

                    localStorage.setItem('token', token);
                    api.setCommonHeader('Authorization', "Bearer " + token);

                    commit('authSuccess', { token, user });
                    resolve(response);

                }).catch(err => {
                    commit('authError');
                    localStorage.removeItem('token');
                    reject(err);
                });
        });
    },

    getUserData({commit}) {
      return new Promise((resolve, reject) => {

        commit('authRequest');

        api.auth('/getUserData')
            .then(response => {

                const user = userModel.defaultUser();
                const token = localStorage.getItem('token');
                let u = response.data.user;
                const notifications = response.data.notificationNumber;

                user.id = u.id;
                user.displayName = u.displayName;
                user.status = u.status;
                user.settings = u.settings;

                for (let i = 0; i < u.forumRoles.length; i++) {
                    user.roles.push(u.forumRoles[i]);
                }

                localStorage.setItem('token', token);
                api.setCommonHeader('Authorization', "Bearer " + token);

                commit('authSuccess', { token, user, notifications });
                commit('notifications/setNotificationsNumber', notifications);
                resolve(response);

            }).catch(err => {
                commit('authError');
                localStorage.removeItem('token');
                reject(err);
            });
      });
    },

    register({ commit }, registrationData) {

        return new Promise((resolve, reject) => {

            commit('authRequest');

            api.auth('/register', registrationData)
                .then(response => {

                    const user = userModel.defaultUser();
                    let u = response.data.user;

                    user.id = u.id;
                    user.displayName = u.displayName;
                    user.status = u.status;
                    for (let i = 0; i < u.forumRoles; i++) {
                        user.roles.push(u.forumRoles[i]);
                    }

                    resolve(response);

                }).catch(err => {
                    commit('authError');
                    localStorage.removeItem('token');
                    reject(err);
                });
        });
    },

    logout({ commit }) {

        return new Promise((resolve) => {

            commit('logout');

            localStorage.removeItem('token');
            localStorage.removeItem('remember-me');
            localStorage.removeItem('username');
            localStorage.removeItem('pass');
            delete api.removeCommonHeader('Authorization');

            resolve();

        });
    }

};

export default loginActions;